module.exports = __webpack_public_path__ + "static/media/vip-room.f8e5fbee.png";